module.exports = __webpack_public_path__ + "img/PSLRLOC.4ba3d6ef.svg";